import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServiceHero from './components/ServiceHero';
import ServiceBlocks from './components/ServiceBlocks';

export default function Services() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ServiceHero />
      <ServiceBlocks />
      <Footer />
    </div>
  );
}